module.exports = __webpack_public_path__ + "img/document-refused.4bab1be3.svg";